<div class="search-suggestions-dropdown" *ngIf="isOpen && suggestions.length">
    <div class="dropdown-heading" *ngIf="showPopularHeading">Popular Right Now</div>
    <ul class="suggestions-list" role="listbox">
        <li
            *ngFor="let suggestion of suggestions; let i = index"
            class="suggestion-item"
            role="option"
            [attr.aria-selected]="i === activeIndex"
            [class.active]="i === activeIndex"
            [class.last-smart-suggestion]="isLastSuggestion(i)"
            (mousedown)="$event.preventDefault()"
            (click)="onSelect(suggestion)"
        >
            {{ capitalizeFirstLetter(suggestion) }}
        </li>
    </ul>
</div>
